import { useState } from 'react';
import { ApiError, login } from '../lib/api.ts';
import { Alert, AsyncButton, Field } from '../ui.tsx';

/**
 * เข้าสู่ระบบ
 *
 * ใช้คีย์บอร์ดของระบบที่นี่ได้ ต่างจากหน้าอื่น ๆ — เพราะกรอกวันละครั้งตอนเปิดร้าน
 * ไม่ใช่ระหว่างมีลูกค้ายืนรอ
 */
export function LoginScreen() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setError(null);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(
        err instanceof ApiError || err instanceof Error
          ? err.message
          : 'เข้าสู่ระบบไม่สำเร็จ',
      );
    }
  };

  return (
    <div className="page" style={{ maxWidth: 420, paddingTop: 60 }}>
      <h1>ซูชิมั้ย</h1>
      <p className="lede">เข้าสู่ระบบเพื่อเริ่มขาย</p>

      {error && <Alert>{error}</Alert>}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <Field label="ชื่อผู้ใช้">
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            autoFocus
          />
        </Field>
        <Field label="รหัสผ่าน">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </Field>
        <AsyncButton
          className="btn big wide"
          onClick={submit}
          disabled={username.trim() === '' || password === ''}
        >
          เข้าสู่ระบบ
        </AsyncButton>
      </form>
    </div>
  );
}
